import request from "../util/request";
import {APP_KEY, API_URL, WEB_CODE} from "../util/constants";

export function getStudentList(namekey,offset,limit, callback) {

    let formData = new FormData();
    formData.append("user_type", "student");
    formData.append("caozuo", "list");
    formData.append("utoken", sessionStorage.getItem("utoken"));
    formData.append("namekey", namekey);
    formData.append("offset", offset);
    formData.append("limit", limit);

    return fetch(API_URL + '/index.php/ApiAdmin/user', {
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}
export function editStudent(user_name,user_pwd,user_code, callback) {

    let formData = new FormData();
    formData.append("caozuo", "update");
    formData.append("utoken", sessionStorage.getItem("utoken"));
    formData.append("user_name", user_name);
    formData.append("user_pwd", user_pwd);
    formData.append("user_code", user_code);

    return fetch(API_URL + '/index.php/ApiAdmin/user', {
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}

export function deleteStudent(user_code, callback) {

    let formData = new FormData();
    formData.append("caozuo", "del");
    formData.append("utoken", sessionStorage.getItem("utoken"));
    formData.append("user_code", user_code);

    return fetch(API_URL + '/index.php/ApiAdmin/schooldel', {
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        // console.log(json)
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function jinyongStudent(user_code, callback) {

    let formData = new FormData();
    formData.append("caozuo", "jinyong");
    formData.append("utoken", sessionStorage.getItem("utoken"));
    formData.append("user_code", user_code);

    return fetch(API_URL + '/index.php/ApiAdmin/user', {
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        // console.log(json)
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
export function qiyongStudent(user_code, callback) {

    let formData = new FormData();
    formData.append("caozuo", "qiyong");
    formData.append("utoken", sessionStorage.getItem("utoken"));
    formData.append("user_code", user_code);

    return fetch(API_URL + '/index.php/ApiAdmin/user', {
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        // console.log(json)
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
export function getStudentXueyuanBadge(studentid, callback) {

    let formData = new FormData();
    formData.append("appkey", "xixin");
    formData.append("caozuo", "getdata");
    formData.append("studentid", studentid);


    return fetch(API_URL + '/index.php/Apiopen/sd', {
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        // console.log(json)
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}
